export default function Footer() {
  return (
    <footer className="w-full bg-[#1A1A1A] text-white">
      <div className="section-container py-10 md:py-12">
        {/* Company Info */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-8">
          <div className="flex items-center gap-3">
            <div>
              <h3 className="text-white font-bold text-sm">株式会社TBM健康美容研究所</h3>
              <p className="text-white/60 text-xs">TBM Health & Beauty Research Institute</p>
            </div>
          </div>
          <div className="text-white/70 text-sm space-y-1">
            <p>〒370-0841 群馬県高崎市栄町13-1</p>
            <p>TEL: 027-310-2220 / FAX: 027-327-6344</p>
          </div>
        </div>

        {/* Partnership Links */}
        <div className="border-t border-white/10 pt-6 mb-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
            <span className="text-white/40 text-xs tracking-wider">連携教育機関</span>
            <a
              href="https://www.chuo.ac.jp/tbm/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 text-sm hover:text-white transition-colors flex items-center gap-1.5"
            >
              <i className="ri-school-line text-sm"></i>
              <span>高崎ビューティモード専門学校</span>
              <i className="ri-external-link-line text-[10px]"></i>
            </a>
            <span className="text-white/20 hidden sm:block">|</span>
            <a
              href="/links"
              className="text-white/70 text-sm hover:text-white transition-colors flex items-center gap-1.5"
            >
              <i className="ri-building-line text-sm"></i>
              <span>中央カレッジグループ リンク集</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              <a href="/privacy" className="text-white/60 text-xs hover:text-white transition-colors">
                プライバシーポリシー
              </a>
              <a href="/cookie" className="text-white/60 text-xs hover:text-white transition-colors">
                cookieポリシー
              </a>
            </div>
            <small className="text-white/40 text-xs">
              Copyright TBM Health & Beauty Research Institute Co.,LTD.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}